import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductsIndexPage from "@/pages/ProductsIndexPage";
import BearingsPage from "@/pages/BearingsPage";
import BesseyPage from "@/pages/BesseyPage";
import IndustriesPage from "@/pages/IndustriesPage";
import CertificatesPage from "@/pages/CertificatesPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import { PrivacyPage, TermsPage } from "@/pages/LegalPages";
import useGa4 from "@/hooks/useGa4";

function AppRoutes() {
  useGa4();
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminDashboardPage />} />
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsIndexPage />} />
        <Route path="/products/industrial-bearings" element={<BearingsPage />} />
        <Route path="/products/bessey-clamps" element={<BesseyPage />} />
        <Route path="/products/:slug" element={<ProductsPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/brands" element={<Navigate to="/" replace />} />
        <Route path="/downloads" element={<Navigate to="/certificates" replace />} />
        <Route path="/certificates" element={<CertificatesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
export default App;
